<template>
  <main id="about-page">
    <ContentTitle :category="$t('sideMenu.Firmware')" :categoryIcon="'scf-traced'"
      :title="$t('sideMenu.FirmwareList')" />

    <div style="max-width: 100%">
      <div class="row" style="
          align-content: flex-end;
          justify-content: flex-end;
          padding-top: 10px;
        "></div>
      <div class="row">
        <div style="flex: auto" v-if="componentKey > 0">
          <!-- group panel -->
          <OdataFlexGrid :key="componentKey" :Api="{
            base: urlOdata + 'api/v1/OData/',
            controller: 'TransmitterFirmwares',
          }" :FiltersDefinition="FiltersDefinition" :ColumnsDefinition="columns" :allowPinning="'SingleColumn'"
            :FilterColumns="[
              'State',
              'Source',
              'FirmwareVersion',
              'Manufacturer',
              'CreatedDate',
              'ExternalId',
            ]" :requestHeaders="gridHeaders" :displayLang="culture" v-on:initializedGrid="gridInitialized" v-on:gridFilterChanged="gridFilterChanged"
            :GridId="'firmwareList'" :ExportsButtons="{
              Header: ExportsHeader,
              DataSource: ExportsDataSource,
              Events: ExportsEvents,
            }" :WijmoLicense="config.value('VUE_APP_WIJMO_LICENCE')" v-on:format-columns="formatColumns"
            v-on:column-visibility-changed="componentKey++" />
          <!-- END Grid -->
        </div>
        <p></p>
      </div>
    </div>
  </main>
</template>

<script>
import { defineComponent, computed } from "vue";
import Swal from "sweetalert2";
import MainService from "../services/MainService";
import utils from "../Utils/libraries";
import "sweetalert2/dist/sweetalert2.min.css";
import Configs from "../../configs";
import "@grapecity/wijmo.styles/wijmo.css";
import * as wijmo from "@grapecity/wijmo";
import ContentTitle from "@supervision/vue-components/components/ContentTile";
import * as wjcGridXlsx from "@grapecity/wijmo.grid.xlsx";
import OdataFlexGrid from "@supervision/vue-components/components/OdataFlexGrid.vue";

export default defineComponent({
  name: "FirmwareList",
  inject: ["accessToken", "currentScope"],
  components: {
    OdataFlexGrid,
    ContentTitle,
  },
  data() {
    return {
      gridHeaders: {
        authorization: `bearer ${this.accessToken}`,
        'X-Current-Scope': computed(() => this.isPreselectedScope ? this.preselectedScope : this.currentScopeView),
        'X-Custom-Filters': computed(() => this.headerFilters),
      },
      componentKey: 0,
      mainService: new MainService(this.$jwt.token, this.currentScopeView),
      config: Configs,
      theGrid: null,
      latestDataState: null,
      culture: computed(() => this.$i18n.locale),
      urlOdata: Configs.value("VUE_APP_WEBAPI"),
      filter: null,
      FiltersDefinition: [
        {
          binding: "State",
          hasValueFilter: true,
          hasConditionFilter: false,
          values: [
            {
              id: "Pending",
              label: computed(() => this.getTraductionState("Pending")),
            },
            {
              id: "Ready",
              label: computed(() => this.getTraductionState("Ready")),
            },
            {
              id: "Failed",
              label: computed(() => this.getTraductionState("Failed")),
            },
          ],
        },
        {
          binding: "Source",
          hasValueFilter: true,
          hasConditionFilter: false,
        },
        {
          binding: "FirmwareVersion",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "Manufacturer",
          hasValueFilter: true,
          hasConditionFilter: false,
        },
        {
          binding: "ExternalId",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "CreatedDate",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
      ],
      ExportsHeader: { text: "Exports", icon: "scf-export" },
      ExportsDataSource: [
        { text: "Export as Csv", method: "exportCsv", icon: "scf-csv" },
        { text: "Export as Excel", method: "exportExcel", icon: "scf-excel" },
      ],
      ExportsEvents: {
        exportCsv: this.exportCsv,
        exportExcel: this.exportExcel,
      },
      columns: [
        {
          binding: "ExternalId",
          width: "*",
          header: computed(() =>
            this.$t("pages.FirmwareList.columns.ExternalId")
          ),
        },
        {
          binding: "CreatedDate",
          width: "*",
          dataType: "Date",
          format: "MM/dd/yyyy",
          header: computed(() =>
            this.$t("pages.FirmwareList.columns.CreatedDate")
          ),
        },
        {
          binding: "Manufacturer",
          width: "*",
          header: computed(() =>
            this.$t("pages.FirmwareList.columns.Manufacturer")
          ),
        },
        {
          binding: "FirmwareVersion",
          width: "*",
          header: computed(() =>
            this.$t("pages.FirmwareList.columns.FirmwareVersion")
          ),
        },
        {
          binding: "Source",
          width: "*",
          header: computed(() => this.$t("pages.FirmwareList.columns.Source")),
        },
        {
          binding: "State",
          width: "*",
          header: computed(() => this.$t("pages.FirmwareList.columns.State")),
        },
        { header: "Actions", width: "*" },
      ],
      exportRoot:
        Configs.value("VUE_APP_WEBAPI") +
        "api/v1/OData/TransmitterFirmwares/export?",
    };
  },
  beforeCreate() {
    this.currentScopeView = this.currentScope ?? this.$jwt.scope;
  },
  created() {
    this.currentScopeView = this.currentScope ?? this.$jwt.scope;
  },
  mounted() {
    if (this.currentScopeView) {
      this.componentKey += 1;
    }
  },
  methods: {
    gridFilterChanged(data) {
      this.latestDataState = data;
      console.log("data grid :    ", this.latestDataState);
    },
    exportExcel() {
      console.log(utils.GetIsoCulture(this.$i18n.locale));
      const filter =
        this.latestDataState !== null && this.latestDataState !== undefined
          ? this.latestDataState.filterDefinition
          : "";
      let exportUrl = `${this.exportRoot}cultureName=${this.$i18n.locale}&exporFormat=excel`;
      if (filter != "") {
        exportUrl = `${this.exportRoot}cultureName=${this.$i18n.locale}&filter=${filter}&exporFormat=excel`;
      }

      console.log(exportUrl);

      this.mainService
        .Export(exportUrl, this.gridHeaders)
        .then((response) => {
          console.log(response);
          const type = response.headers["content-type"];
          utils.DownloadBytes("firmwareList", type, "xlsx", response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    exportCsv() {
      console.log(utils.GetIsoCulture(this.$i18n.locale));
      const filter =
        this.latestDataState !== null && this.latestDataState !== undefined
          ? this.latestDataState.filterDefinition
          : "";
      let exportUrl = `${this.exportRoot}cultureName=${this.$i18n.locale}&exporFormat=csv`;
      if (filter != "") {
        exportUrl = `${this.exportRoot}cultureName=${this.$i18n.locale}&filter=${filter}&exporFormat=csv`;
      }

      console.log(exportUrl);

      this.mainService
        .Export(exportUrl, this.gridHeaders)
        .then((response) => {
          const type = response.headers["content-type"];
          utils.DownloadBytes("firmwarelist", type, "csv", response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    DownloadFirmwareZip(e, p) {
      console.log(p);
      var Arr = this.base64ToArrayBuffer(e);
      this.saveByteArray(p, Arr);
      Swal.fire({
        position: "bottom-end",
        icon: "success",
        title: this.$t("pages.Utils.filedownloaded"),
        showConfirmButton: false,
        timer: 1500,
      });
    },
    base64ToArrayBuffer(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    saveByteArray(reportName, byte) {
      var blob = new Blob([byte], { type: "application/zip" });
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      var fileName = reportName;
      link.download = fileName;
      link.click();
    },
    gridInitialized(flexgrid) {
      this.theGrid = flexgrid;
      var event = this.DownloadFirmwareZip.bind(this);

      flexgrid.hostElement.addEventListener("click", function (e) {
        let action = e.target.getAttribute("action-type-FirmwarePackage");
        if (!action) {
          return;
        }
        var hitTest = flexgrid.hitTest(e);
        var data = flexgrid.rows[hitTest.row].dataItem;
        event(data.FirmwarePackage, data.ExternalId);
      });
    },
    exportPage(exportToType) {
      if (exportToType === "excel") {
        let book = wjcGridXlsx.FlexGridXlsxConverter.save(this.theGrid);
        book.sheets[0].name = "firmwares";
        book.save("FirmwareList.xlsx");
      }
    },
    downloadfile() {

    },
    substringIfGreaterThanTweenty(e) {
      if (e.length > 20) {
        return e.substring(0, 17).concat("", "...");
      } else return e;
    },
    formatColumns: function (s, e) {
      const flex = s;

      if (e.panel == flex.cells) {

        if (flex.rows[e.row].dataItem.name) return;

        switch (flex.columns[e.col].header) {
          case "Actions":
            e.cell.innerHTML =
              wijmo.format(
                '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" style="margin-left:10px" class="bi bi-trash" viewBox="0 0 16 16"><path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/><path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/></svg>',
                s.rows[e.row].dataItem
              ) +
              wijmo.format(
                '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" style="margin-left:10px" class="bi bi-arrow-repeat" viewBox="0 0 16 16"><path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z"/><path fill-rule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z"/></svg>',
                s.rows[e.row].dataItem
              );

            break;
        }

        switch (flex.columns[e.col].binding) {
          case "graph":
            e.cell.innerHTML =
              wijmo.format(
                '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" style="margin-left:10px" class="bi bi-trash" viewBox="0 0 16 16"><path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/><path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/></svg>',
                s.rows[e.row].dataItem
              ) +
              wijmo.format(
                '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" style="margin-left:10px" class="bi bi-arrow-repeat" viewBox="0 0 16 16"><path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z"/><path fill-rule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z"/></svg>',
                s.rows[e.row].dataItem
              );

            break;
          case "CreatedDate":
            {
              e.cell.innerText = this.$d(s.rows[e.row].dataItem.CreatedDate);
            }
            break;

          case "FirmwarePackage":
            e.cell.innerHTML = wijmo.format(
              '<a href="#" action-type-FirmwarePackage="DownloadFirmwareZip">' +
              this.$t("pages.Utils.link"),
              +"</a>",
              s.rows[e.row].dataItem
            );
            break;
        }
      }
    },
    getTraductionState: function (e) {
      return this.tryGetTranslation(`pages.FirmwareList.State.${e}`);
    },
    tryGetTranslation(key) {
      return typeof this.$tm(key) == "string"
        ? this.$t(key)
        : key;
    },
    showmessage() {
      Swal.fire("functionality not yet specified", "", "info");
    },
    async initFilterParameters() {
      this.mainService
        .getDistinct("OData/TransmitterFirmwares", "Manufacturer")
        .then((response) => {
          if (
            typeof response.value != "undefined" &&
            response.value != null &&
            response.value.length != null &&
            response.value.length > 0
          ) {
            var obj = [];

            for (var i = 0; i < response.value.length; i++) {
              if (response.value[i].Manufacturer == null) {
                obj.push({
                  id: "nullValueFilter",
                  label: this.$t("common.nothing"),
                });
                continue;
              }
              obj.push({
                id: response.value[i].Manufacturer,
                label: response.value[i].Manufacturer,
              });
            }
            console.log(obj);
            this.FiltersDefinition.filter(
              (e) => e.binding == "Manufacturer"
            )[0].values = obj;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  watch: {
    currentScope: {
      handler: function (newVal) {
        if (newVal) {
          this.currentScopeView = newVal;
          this.mainService = new MainService(this.$jwt.token, newVal);
          this.initFilterParameters();
          this.componentKey += 1;
        }
      },
      deep: true
    },
    accessToken(newVal) {
      if (newVal) {
        this.mainService = new MainService(newVal, this.currentScopeView);
      }
    },
    culture() {
      if (this.currentScopeView != null && this.currentScopeView !== '')
        this.componentKey += 1;
    }
  },
});
</script>

<style lang="scss" scoped>
@import "../../node_modules/bootstrap/scss/bootstrap.scss";

#about-page {
  font-family: "D-DIN" !important;
}
</style>

<style scoped src="../assets/css/firmwareList.css"></style>
